import { Component, Input } from '@angular/core';

@Component({
  selector: 'frodo-space-open-door-icon',
  templateUrl: './space-open-door-icon.component.html',
  styleUrls: ['./space-open-door-icon.component.scss'],
})
export class SpaceOpenDoorIconComponent {
  @Input() color: string;
  @Input() width: number | string = 240;
  @Input() height: number | string = 240;
}
